import styled from 'styled-components';
import { Container, Col } from 'react-bootstrap';
import searchSiteImage from '../../../images/topMobile-nav-search.png';
import navBarImage from '../../../images/topMobile-nav-nav.png';
import topMobilebg from '../../../images/topMobile-bg.gif'
import toolImage from '../../../images/topMobile-nav-tools.png';

export const MainContainer = styled(Container)`
  position: relative;
  display: block;
    overflow: hidden;
  width: 100%;
  padding: 25px 25px 30px 20px !important;
  border-top: 8px solid rgb(12, 71, 36);
  background-size: 1px auto;
  background: url(${topMobilebg}) left top / 1px repeat-x rgb(255, 255, 255);
  letter-spacing: 0.02em;
  font-size: 15px;
  line-height: 22px;
  text-align: left;
  @media print {
    display: none;
  }
`;
export const TopLogoAnchor = styled.a`

  text-decoration: none;
`;
export const TopLogo = styled.img`
  width: 115px;
  height: auto;

  @media print {
    display: none;
  }
`;

export const TopNav = styled.div`
  float: right;
  width: 130px;
  margin: 20px 0 0 0;
`;

export const NavMenu = styled.a`
  display: block;
  float: right;
  width: 36px;
  height: 36px;
  background: url(${navBarImage}) no-repeat 0 0;
  background-size: 36px auto;
  cursor: pointer;
  &.active {
    background-position: 0 -36px;
  }
`;

export const NavSearchSite = styled(NavMenu)`
  background: url(${searchSiteImage}) no-repeat 0 0;
  background-size: 36px auto;
  cursor: pointer;
  margin-right: 5px;
    display: block;
    float: right;
    width: 36px;
    height: 36px;
    margin-right: 5px;

`;

export const DropDownContainer = styled.div`
  clear: both;
  position: absolute;
  color: #fff;
  text-align: left;
  width: 100%;
  z-index: 2;
  background: #0c4724;
  top: 113px;
`;

export const HeaderMenu = styled.a`
position: relative;
    display: block;
    padding: 10px 10px 10px 10px;
    text-decoration: none;
    font-size: 24px;
    line-height: 26px;
    color: #fff;
    border-top: 1px solid #255a3a;
    border-bottom: 1px solid #062312;
  text-align: left;
  letter-spacing: 0.02em;
  background: #0c4724;
  text-transform: capitalize;
  :hover{
    color: #fff;
  }
`;

export const SubHeaderMenu = styled(HeaderMenu)`
  text-transform: capitalize;
    display: block;
    padding: 10px 10px 10px 30px;
    text-align: left;
    text-decoration: none;
    font-size: 18px;
    line-height: 20px;
    color: #fff;
    border-top: 1px solid #398b47;
    border-bottom: 1px solid #185823;
    background: #237e32;
`;

export const ArrowImageContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 43px;
  height: 43px;
  padding: 17px 0 0 10px;
  cursor: pointer;
`;

export const ArrowImage = styled.img`
  height: 12px;
  width: auto;
  border: 0;
  vertical-align: top;
`;

export const RelativeCol = styled(Col)`
  position: relative;
`;

export const NavTool = styled(NavMenu)`
  background: url(${toolImage}) no-repeat 0 0;
  background-size: 36px auto;
  cursor: pointer;
    display: block;
    float: right;
    width: 36px;
    height: 36px;
    margin-right: 5px;
`;

export const IconHome = styled(ArrowImage)`
  width: 17px;
  height: auto;
  position: absolute;
  top: 15px;
  right: 15px;
`;